module.exports = __webpack_public_path__ + "static/example_2_month-464836cb5594ff104c10df7ea3c20990.png";